import { UISystem } from "../../../system/ui/UISystem";
import { title } from "elmtree";
export function VideoScreen() {
    UISystem.appScreen.screens.add([
        {
            id: "video",
            getElements() {
                return [title("h1", "Video", "screen-title")];
            },
        },
    ]);
}
